import { useCallback } from 'react';

import { boardSwitcherSharedState } from '@trello/board-switcher';
import { useSharedStateSelector } from '@trello/shared-state';

import * as styles from './BoardSwitcherTilesLoadingSkeleton.module.less';

export const BoardSwitcherTilesLoadingSkeleton = () => {
  const layout = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.layout, []),
  );

  if (layout === 'list') {
    return (
      <div className={styles.listTilesWrapper}>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
        <div className={styles.listItem}></div>
      </div>
    );
  }

  return (
    <div className={styles.gridTilesWrapper}>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
      <div className={styles.gridItem}></div>
    </div>
  );
};
